export default {
  name: "CircleInTriangle",
  props: {
    colors: {
      type: String,
      default: 'RGBG'
    }
  },
  data() {
    return {
      color: {
        'R': 'red',
        'G': 'green',
        'B': 'blue'
      }
    };
  },
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
};